export const USER_LIST_ACTION = "USER_LIST_ACTION";
export const USER_LIST_SUCCESS = "USER_LIST_SUCCESS";
export const USER_CREATE_ACTION = "USER_CREATE_ACTION";
export const USER_DELETE_ACTION = "USER_DELETE_ACTION";
export const USER_GET_UPDATE_ACTION = "USER_GET_UPDATE_ACTION";
export const USER_GET_UPDATE_SUCCESS = "USER_GET_UPDATE_SUCCESS";
export const USER_UPDATE_ACTION = "USER_UPDATE_ACTION";
export const USER_FORCE_MFA_UPDATE_ACTION = "USER_FORCE_MFA_UPDATE_ACTION";
export const USER_FORCE_MFA_UPDATE_SUCCESS = "USER_FORCE_MFA_UPDATE_SUCCESS";
export const USER_FORCE_MFA_UPDATE_FAIL = "USER_FORCE_MFA_UPDATE_FAIL";
export const USER_GET_ROLE_ACTION = "USER_GET_ROLE_ACTION";
export const USER_GET_ROLE_SUCCESS = "USER_GET_ROLE_SUCCESS";
export const USER_CHANGE_PASSWORD_ACTION = "USER_CHANGE_PASSWORD_ACTION";
export const USER_CHANGE_PASSWORD_SUCCESS = "USER_CHANGE_PASSWORD_SUCCESS";
export const USER_CHANGE_PASSWORD_FAIL = "USER_CHANGE_PASSWORD_FAIL";
export const USER_FAIL = "USER_FAIL";
export const USER_GET_CS_USER_ACTION = "USER_GET_CS_USER_ACTION";
export const USER_GET_CS_USER_SUCCESS = "USER_GET_CS_USER_SUCCESS";
export const USER_GET_CUSTOMER_USER_ACTION = "USER_GET_CUSTOMER_USER_ACTION";
export const USER_GET_CUSTOMER_USER_SUCCESS = "USER_GET_CUSTOMER_USER_SUCCESS";
